/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Security_User_Api_Key_Create_SuccessInputs */



/**
* | output |
* | --- |
* | "API key created. Save it now, you won't see it again." |
*
* @param {Profile_Security_User_Api_Key_Create_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const profile_security_user_api_key_create_success = /** @type {((inputs?: Profile_Security_User_Api_Key_Create_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Security_User_Api_Key_Create_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("API-Schlüssel erstellt. Speichern Sie ihn jetzt, Sie sehen ihn nicht wieder.")
	return /** @type {LocalizedString} */ ("API key created. Save it now, you won't see it again.")
});